
import { apiRequest } from "./ApiUtility";

export async function getFacilityUsers(auth, userFilter) {
  if (auth == null || userFilter == null) {
    return { isSuccess: false, data: {} };
  }
  
  const url = "/api/account/search";
  const data = {
    facilityid: userFilter.facilityId,
    roles: userFilter.roles
  };
  
  return await apiRequest("post", url, auth, data);
}

export async function registerAccount(auth, accountData) {
  const url = "/api/account/register";
  console.log(JSON.stringify(accountData));
  
 
  
  return await apiRequest("post", url, auth, accountData);
}

export async function searchUsers(auth, searchParams) {
  const url = "/api/account/search";
  const data = {
    facilityId: searchParams?.facilityId,
    roles: searchParams?.roles || []
  };
  
  return await apiRequest("post", url, auth, data);
}